import { Outlet, useNavigate } from 'react-router';

import { useResetViewStateOnSectionLeave } from '@/hooks/useResetViewStateOnSectionLeave';

import { useFeaturePermission } from '@/utils/permissions';
import { useMultipleReportsTabsEnabled } from '@/utils/reports';
import { cn } from '@/utils/tailwind';
import { useRouteMatcher } from '@/utils/url';

import { Header, Tabs } from '@/components/header';

import Constants, { routes } from 'constants/index';

export default function ReportsLayout() {
  useResetViewStateOnSectionLeave('/reports');
  const routeMatches = useRouteMatcher();
  const navigate = useNavigate();
  const reportingPlansEnabled = useFeaturePermission('reporting.plans');
  const reportingTeamMemberEnabled = useFeaturePermission(
    'reporting.teamMember',
  );
  const tabsActive = useMultipleReportsTabsEnabled();

  const activeTab = routeMatches.includes(
    Constants.ROUTE_PATH_GROUPS.ReportsPlansPath,
  )
    ? routes.reports.plans
    : routeMatches.includes(Constants.ROUTE_PATH_GROUPS.ReportsTeamMembersPath)
      ? routes.reports.teamMembers
      : undefined;

  return (
    <div className="w-full">
      <Header.Root>
        <Header.Title tx="Generic.reports" />
        {tabsActive && (
          <Tabs.Root
            selectedKey={activeTab}
            onSelectionChange={navigate}
            style={{
              top: `calc(var(--web-alert-banner-height, 0px)${window.native.isNative ? '' : ' + var(--spacing-header-height, 0px))'}`,
            }}
          >
            {reportingPlansEnabled && (
              <Tabs.Tab id={routes.reports.plans} tx="Reports.tabPlans" />
            )}
            {reportingTeamMemberEnabled && (
              <Tabs.Tab
                id={routes.reports.teamMembers}
                tx="Reports.tabTeamMembers"
              />
            )}
          </Tabs.Root>
        )}
      </Header.Root>
      <div
        className={cn(
          'max-w-content mx-auto px-4 max-md:mt-[78px]',
          tabsActive
            ? 'md:mt-[calc(var(--header-height)+var(--header-content-spacing-lg)+47px)]'
            : 'md:mt-header-height-with-content-spacing-lg',
        )}
      >
        <Outlet />
      </div>
    </div>
  );
}
